<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">

  <div class="bg-card flex min-w-0 flex-auto flex-col dark:bg-transparent sm:absolute sm:inset-0 sm:overflow-hidden">
    <div class="ml-6 mt-6 text-4xl font-extrabold tracking-tight">Generación de Pedidos</div>

    <!-- Actions buttons -->
    <div class="flex w-full justify-end p-4">
      <button mat-button color="primary" (click)="openCreateModal()" matTooltip="Guardar Carrito"
        [disabled]="selectedSoldToId === 'none' || selectedShipToId === 'none'">
        <mat-icon svgIcon="heroicons_solid:shopping-bag"></mat-icon>
        <span class="ml-2">
          Guardar Carrito
        </span>
      </button>
      <button mat-button color="primary" (click)="openOrdersVerificationModal()" matTooltip="Verificando Órdenes">
        <mat-icon svgIcon="heroicons_solid:star"></mat-icon>
        <span class="ml-2">
          Verificando Órdenes (Mock)
        </span>
      </button>
    </div>

    <!-- Main Content -->
    <div class="flex flex-auto overflow-scroll flex-col p-4">
      <mat-accordion [multi]="true" class="flex flex-col">
        <div class="h-full overflow-auto">
          <!-- Datos de Cabecera -->
          <mat-expansion-panel class="mt-2 flex flex-col rounded-md border-2" [expanded]="!orderHeadersCollapsed">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span>
                  Datos de Cabecera
                </span>
              </mat-panel-title>
              <mat-panel-description *ngIf="selectedShipToBP"> Se envía a: {{ selectedShipToBP.name }}
              </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-tab-group>
              <!-- Tab Datos Principales -->
              <mat-tab label="Datos Principales">
                <!-- Primera Fila -->
                <div class="px-6 py-6 w-full mt-6 flex flex-col shrink-0 items-center sm:flex-row sm:mt-0">
                  <!-- Dropdown filters -->
                  <div class="w-full mt-6 flex flex-col items-center sm:flex-row sm:mt-0">
                    <!-- Select de Oficina de Ventas -->
                    <mat-form-field class="mt-4 w-full sm:w-1/5 sm:mx-4">
                      <mat-label>Oficina de Ventas</mat-label>
                      <input type="text" placeholder="Selecciona Oficina de Ventas" aria-label="Text" matInput
                        [formControl]="salesOfficeControl" [matAutocomplete]="autoSalesOffice">
                      <mat-autocomplete autoActiveFirstOption #autoSalesOffice="matAutocomplete"
                        [displayWith]="fetchSalesOfficeName">
                        <mat-option *ngFor="let salesOffice of salesOffices$ | async" [value]="salesOffice._id">
                          {{ salesOffice.name }}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                    <!--  Select de Clase de Pedido -->
                    <mat-form-field class="mt-4 w-full sm:w-1/5">
                      <mat-label>Clase de Pedido</mat-label>
                      <input type="text" placeholder="Selecciona Clase de Pedido" aria-label="Clase de Pedido" matInput
                        [formControl]="orderTypeControl" [matAutocomplete]="autoOrderType">
                      <mat-autocomplete #autoOrderType="matAutocomplete" [displayWith]="fetchOrderTypeName">
                        @for (orderType of filteredDocumentClasses$ | async; track orderType) {
                        <mat-option [value]="orderType._id">
                          {{ orderType.name }}
                        </mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                    <!-- Select de Sub-Ruta -->
                    <mat-form-field class="mt-4 w-full sm:w-1/5 sm:mx-4">
                      <mat-label>Sub-Ruta</mat-label>
                      <input type="text" placeholder="Selecciona una Sub-Ruta" aria-label="Number" matInput
                        [formControl]="subRouteControl" [matAutocomplete]="autoSubRoute">
                      <mat-autocomplete autoActiveFirstOption #autoSubRoute="matAutocomplete"
                        [displayWith]="fetchSubRouteName">
                        <mat-option *ngFor="let location of subRoutesList$ | async" [value]="location._id">
                          {{ location.name }}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                    <!-- Ruta de Entrega -->
                    <div class="flex flex-col mx-4 text-center w-full sm:w-1/5">
                      <span class="text-black mb-1">
                        Ruta de Entrega
                      </span>
                      <span *ngIf="selectedRoute?.name; else selectionPending">
                        {{ selectedRoute.name }}
                      </span>
                    </div>
                    <!-- Select de ShipTo (Se le envía a) -->
                    <mat-form-field class="mt-4 w-full sm:w-1/5">
                      <mat-label>Se Le Envía A</mat-label>
                      <input type="text" placeholder="Selecciona cliente" aria-label="Selecciona cliente" matInput
                        [formControl]="shipToControl" [matAutocomplete]="autoShipTo">
                      <mat-autocomplete #autoShipTo="matAutocomplete" [displayWith]="fetchShipToName">
                        @for (location of shipToList; track location) {
                        <mat-option [value]="location._id">
                          {{ location.name }}
                        </mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                    <!-- Se cobra a -->
                    <div class="flex flex-col ml-4 text-center w-full sm:w-1/5">
                      <span class="text-black mb-1">
                        Se le Cobra A
                      </span>
                      <span *ngIf="selectedSoldToBP?.name; else selectionPending">
                        {{ selectedSoldToBP.name }}
                      </span>
                    </div>
                  </div>
                </div>
                <!-- Segunda Fila -->
                <div class="px-6 py-6 w-full mt-6 flex flex-col shrink-0 items-center sm:flex-row sm:mt-0">
                  <div class="w-full mt-6 flex flex-col items-center sm:flex-row sm:mt-0">
                    <!-- Select de Almacén -->
                    <mat-form-field class="mt-4 w-full sm:w-1/5 sm:mx-4">
                      <mat-label>Almacén</mat-label>
                      <input type="text" placeholder="Selecciona Almacén" aria-label="Almacén" matInput
                        [formControl]="warehouseControl" [matAutocomplete]="autoWarehouse">
                      <mat-autocomplete #autoWarehouse="matAutocomplete" [displayWith]="fetchWarehouseName">
                        @for (warehouse of filteredWarehouses$ | async; track warehouse) {
                        <mat-option [value]="warehouse._id">
                          {{ warehouse.name }}
                        </mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                    <!-- Select de Fecha de Carga -->
                    <mat-form-field class="mt-4 w-full sm:w-1/5 sm:mx-4">
                      <mat-label>Fecha de Carga</mat-label>
                      <input matInput [matDatepicker]="chargeDatePicker" [formControl]="chargeDateControl">
                      <mat-hint class="text-center">MM/DD/YYYY</mat-hint>
                      <mat-datepicker-toggle matIconSuffix [for]="chargeDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker #chargeDatePicker></mat-datepicker>
                    </mat-form-field>
                    <!-- Select de Fecha de Entrega -->
                    <mat-form-field class="mt-4 w-full sm:w-1/5 sm:mx-4">
                      <mat-label>Fecha de Entrega</mat-label>
                      <input matInput [matDatepicker]="deliveryDatePicker" [formControl]="deliveryDateControl">
                      <mat-hint class="text-center">MM/DD/YYYY</mat-hint>
                      <mat-datepicker-toggle matIconSuffix [for]="deliveryDatePicker"></mat-datepicker-toggle>
                      <mat-datepicker #deliveryDatePicker></mat-datepicker>
                    </mat-form-field>
                    <!--  Input de Hora de Entrega -->
                    <mat-form-field class="mt-4 w-full sm:w-1/5">
                      <mat-label>Hora de Entrega</mat-label>
                      <input matInput type="time" placeholder="Ingresa Hora de Entrega" aria-label="Hora de Entrega"
                        [formControl]="deliveryHourControl">
                    </mat-form-field>
                    <!-- Select de Referencia -->
                    <mat-form-field class="mt-4 w-full sm:w-1/5 sm:mx-4">
                      <mat-label>Referencia</mat-label>
                      <input type="text" placeholder="Brinda referencia" aria-label="Referencia" matInput
                        [formControl]="referenceControl">
                    </mat-form-field>
                  </div>
                </div>
                <!-- Tercera Fila -->
                <div class="px-6 py-6 w-full mt-6 flex flex-col shrink-0 items-center sm:flex-row sm:mt-0">
                  <div class="w-full mt-6 flex flex-col items-center sm:flex-row sm:mt-0">
                    <!--  Select de Moneda -->
                    <mat-form-field class="mt-4 w-full sm:w-1/5">
                      <mat-label>Moneda</mat-label>
                      <input type="text" placeholder="Selecciona Moneda" aria-label="Currency" matInput
                        [formControl]="currencyControl" [matAutocomplete]="autoCurrency">
                      <mat-autocomplete #autoCurrency="matAutocomplete" [displayWith]="fetchCurrencyName">
                        @for (currency of filteredCurrencies$ | async; track currency) {
                        <mat-option [value]="currency._id">
                          {{ currency.name }}
                        </mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                    <!-- Select de Condición de Pago -->
                    <mat-form-field class="mt-4 w-full sm:w-1/5 sm:mx-4">
                      <mat-label>Condición de Pago</mat-label>
                      <input type="text" placeholder="Selecciona Condición de Pago" aria-label="Text" matInput
                        [formControl]="paymentConditionControl" [matAutocomplete]="autoPaymentCondition">
                      <mat-autocomplete autoActiveFirstOption #autoPaymentCondition="matAutocomplete"
                        [displayWith]="fetchPaymentConditionName">
                        <mat-option *ngFor="let paymentCondition of paymentConditions$ | async"
                          [value]="paymentCondition._id">
                          {{ paymentCondition.name }}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                    <!-- Select de Motivo de Pedido -->
                    <mat-form-field class="mt-4 w-full sm:w-1/5 sm:mx-4">
                      <mat-label>Motivo de Pedido</mat-label>
                      <input type="text" placeholder="Mencione un motivo del pedido" aria-label="Text" matInput>
                    </mat-form-field>
                    <!-- Select de Vendedor -->
                    <mat-form-field class="mt-4 w-full sm:w-1/5 sm:mx-4">
                      <mat-label>Vendedor</mat-label>
                      <input type="text" placeholder="Selecciona Vendedor" aria-label="Text" matInput
                        [formControl]="salesForceControl" [matAutocomplete]="autoSalesForce">
                      <mat-autocomplete autoActiveFirstOption #autoSalesForce="matAutocomplete"
                        [displayWith]="fetchSalesForceName">
                        <mat-option *ngFor="let salesForce of salesForces$ | async" [value]="salesForce._id">
                          {{ salesForce.name }}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>
                </div>
              </mat-tab>
              <!-- Tab Datos Principales -->
              <mat-tab label="Observaciones">
                <span>
                  Anote cualquier observación que desee añadir a la orden
                </span>
                <textarea class="w-full border rounded-lg" [formControl]="comentariesControl"></textarea>
              </mat-tab>
            </mat-tab-group>
          </mat-expansion-panel>
          <!-- Materiales -->
          <mat-expansion-panel class="mt-2 flex flex-col rounded-md border-2" [expanded]="!materialsCollapsed">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span>
                  Materiales
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <!-- Búsqueda de Materiales -->
            <mat-form-field class="fuse-mat-dense fuse-mat-rounded min-w-64 mb-4" subscriptSizing="dynamic">
              <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:magnifying-glass"></mat-icon>
              <input matInput placeholder="Buscar material por nombre" autocomplete="off"
                (input)="onSearchChange($event)" />
            </mat-form-field>
            <!-- Tabla -->
            <div class="mt-0 flex-auto flex-col overflow-x-auto p-3">
              <div class="top-0 bg-gray-100 dark:bg-gray-900">
                <table class="min-w-500 overflow-y-visible mat-elevation-z" mat-table [dataSource]="materialsList"
                  matSort [trackBy]="trackByFn">
                  <!-- Producto -->
                  <ng-container matColumnDef="product">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left first-col">Producto</th>
                    <td mat-cell *matCellDef="let material" class="px-6 text-left first-col">
                      <div class="flex flex-row">
                        <div class="flex flex-col mr-4">
                          <span class="font-bold">
                            Posición
                          </span>
                          <span>
                            {{ material.position }}
                          </span>
                        </div>
                        <div class="flex flex-col">
                          <span class="text-xl font-bold">
                            Código y Nombre del Material
                          </span>
                          <span>
                            {{ material.code + ' - ' + material.name }}
                          </span>
                        </div>
                      </div>
                      <div class="flex flex-col">
                        <!-- Select de Almacén -->
                        <mat-form-field appearance="fill" class="col-span-2 mt-3">
                          <mat-label>Almacén</mat-label>
                          <mat-select [value]="material.warehouseId" name="warehouse">
                            <mat-option *ngFor="let warehouse of warehousesList" [value]="warehouse._id">
                              {{ warehouse.name }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </td>
                  </ng-container>

                  <!-- ltsLbs -->
                  <ng-container matColumnDef="ltsLbs">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">ltsLbs</th>
                    <td mat-cell *matCellDef="let material" class="px-6 text-left">
                      <span class="font-bold">
                        ltsLbs
                      </span>
                      <div>
                        <span>
                          {{ material.ltsLbs }}
                        </span>
                      </div>
                    </td>
                  </ng-container>

                  <!-- Precio -->
                  <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Precio {{ 'code' | companyCurrency: true }}</th>
                    <td mat-cell *matCellDef="let material" class="px-6 text-left">
                      <span class="font-bold">
                        Precio
                      </span>
                      <div>
                        <span>
                          {{ material.price }}
                        </span>
                      </div>
                    </td>
                  </ng-container>

                  <!-- Cantidad -->
                  <ng-container matColumnDef="quantity">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left">Cantidad</th>
                    <td mat-cell *matCellDef="let material" class="px-6">
                      <mat-form-field class="fuse-mat-dense min-w-64" subscriptSizing="dynamic">
                        <mat-label class="font-bold">
                          Cantidad
                        </mat-label>
                        <input matInput autocomplete="off" type="number" [value]="material.quantity"
                          (input)="onQuantityChange($event, material)" />
                      </mat-form-field>
                    </td>
                  </ng-container>

                  <!-- Unidad de Medida -->
                  <ng-container matColumnDef="um">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">Unidad de Medida</th>
                    <td mat-cell *matCellDef="let material" class="px-6">
                      <div class="mt-4 flex flex-col">
                        <mat-form-field class="fuse-mat-dense">
                          <mat-label class="font-bold">
                            Unidad de Medida
                          </mat-label>
                          <mat-select class="border-t-0 border-x-0" name="measurementUnit"
                            [value]="material.selectedMeasurement"
                            (selectionChange)="measurementUnitSelected($event, material)">
                            <mat-option *ngFor="let measurement of material.alternalUnitOfMeasures"
                              [value]="measurement.unitOfMeasure._id">
                              {{ measurement.unitOfMeasure.name }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </td>
                  </ng-container>

                  <!-- UMP -->
                  <ng-container matColumnDef="ump">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-6 text-left">UMP</th>
                    <td mat-cell *matCellDef="let material" class="px-6">
                      <div *ngIf="material.UMPActive" class="flex flex-col">
                        <span class="font-bold">
                          Conversión de Unidad
                        </span>
                        <span>
                          {{ fetchUMPConversion(material) }}
                        </span>
                      </div>
                    </td>
                  </ng-container>


                  <!-- Subtotal -->
                  <ng-container matColumnDef="subtotal">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-center">Subtotal {{ 'code' | companyCurrency: true }}</th>
                    <td mat-cell *matCellDef="let material" class="px-6">
                      <div class="flex flex-col">
                        <span>
                          <b>
                            Subtotal
                          </b>
                        </span>
                        <span>
                          {{ material.subtotal}}
                        </span>
                      </div>
                    </td>
                  </ng-container>

                  <!-- Header Row -->
                  <!-- <tr mat-header-row *matHeaderRowDef="displayedColumns" class="bg-gray-100 dark:bg-gray-900"></tr> -->

                  <!-- Fila principal -->
                  <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="border-b"></tr>
                </table>
              </div>
            </div>

            <!-- Paginación -->
            <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
              <mat-paginator class="z-10" [pageSizeOptions]="[pageSize, 25, 50, 100]" showFirstLastButtons
                [length]="totalItems" [pageIndex]="pageIndex"></mat-paginator>
            </div>
          </mat-expansion-panel>
        </div>
      </mat-accordion>

    </div>

    <!-- Modales -->
    <!-- Modal de resumen de órden -->
    <ng-template #addModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Crear Nueva Orden</h2>
      <mat-dialog-content class="flex flex-col w-full justify-center">
        <div class="flex flex-row justify-between text-black mb-2">
          <div class="flex flex-col">
            <span>
              Orden Para:
            </span>
            <span>
              {{ currentOrderRequest.orders[0].soldTo.name }}
            </span>
          </div>
          <div class="flex flex-col">
            <span>
              Se entrega en:
            </span>
            <span>
              {{ currentOrderRequest.orders[0].shipTo.address.address }}
            </span>
          </div>
          <div class="flex flex-col">
            <span>
              Se entrega a:
            </span>
            <span>
              {{ currentOrderRequest.orders[0].shipTo.name }}
            </span>
          </div>
        </div>
        <h3 class="mt-2">
          Resumen del pedido
        </h3>
        <ul class="mt-2">
          <span>
            Listado de productos:
          </span>
          <li *ngFor="let detail of currentOrderRequest.orders[0].detail; let i = index"
            class="flex justify-between text-neutral-800"
            [ngClass]="(i + 1) === currentOrderRequest.orders[0].detail.length ? 'border-b' : '' ">
            <span>
              {{ detail.material.name }}
            </span>
            <span>
              {{ detail.material.quantity }} x {{ detail.material.price}}
            </span>
          </li>
        </ul>
        <div class="flex flex-col">
          <div class="flex flex-row justify-between">
            <div>
              <span>
                Total
              </span>
            </div>
            <div>
              <span>
                {{ currentTotal}}
              </span>
            </div>
          </div>
          <div class="flex flex-row justify-between">
            <div>
              <span>
                Subtotal
              </span>
            </div>
            <div>
              <span>
                {{ currentSubTotal}}
              </span>
            </div>
          </div>
          <div class="flex flex-row justify-between">
            <div>
              <span>
                Impuesto
              </span>
            </div>
            <div>
              <span>
                {{ currentTaxTotal}}
              </span>
            </div>
          </div>
          <div class="flex flex-row justify-between">
            <div>
              <span>
                Total a pagar
              </span>
            </div>
            <div>
              <span>
                {{ currentTotal + currentTaxTotal}}
              </span>
            </div>
          </div>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="true">Confirmar Orden</button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Order Verification Modal -->
    <ng-template #orderVerificationModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Verificación de Órdenes</h2>
      <mat-dialog-content class="flex w-full justify-center">
        <mat-accordion [multi]="true" class="flex flex-col w-11/12">
          <div class="h-full overflow-auto">
            <mat-expansion-panel *ngFor="let orderInvalid of ordersFiltered.invalid"
              class="mt-2 flex flex-col rounded-md bg-red-300" hideToggle [expanded]="!orderInvalid.collapsed">
              <mat-expansion-panel-header class="hover:bg-red-400">
                <mat-panel-title>
                  <span class="flex flex-row content-center">
                    Orden Inválida
                    <mat-icon class="ml-2 text-red-800" svgIcon="heroicons_outline:exclamation-triangle"></mat-icon>
                  </span>
                </mat-panel-title>
                <mat-panel-description> #{{ orderInvalid.code }} </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="flex flex-row justify-between text-black mb-2">
                <div class="flex flex-col">
                  <span>
                    Orden Para:
                  </span>
                  <span>
                    {{ orderInvalid.soldTo.name }}
                  </span>
                </div>
                <div class="flex flex-col">
                  <span>
                    Se entrega en:
                  </span>
                  <span>
                    {{ orderInvalid.shipTo.address.address }}
                  </span>
                </div>
                <div class="flex flex-col">
                  <span>
                    Se entrega a:
                  </span>
                  <span>
                    {{ orderInvalid.shipTo.name }}
                  </span>
                </div>
                <div class="flex flex-col">
                  <span>
                    Fecha de entrega:
                  </span>
                  <span class="text-red-800">
                    No se puede entregar, orden inválida
                  </span>
                </div>
              </div>
              <div>
                <div class="border-b w-full text-start mb-2">
                  <span class="text-xl text-red-700 font-semibold">
                    Materiales
                  </span>
                </div>
                <div *ngFor="let detail of orderInvalid.detail; let i = index"
                  class="flex justify-between text-neutral-800"
                  [ngClass]="(i + 1) === orderInvalid.detail.length ? 'border-b' : '' ">
                  <span>
                    {{ detail.material.name }}
                  </span>
                  <span>
                    {{ detail.material.price}}
                  </span>
                </div>
                <div class="flex justify-between text-neutral-800 mt-2">
                  <span>
                    Total de la orden
                  </span>
                  <span>
                    {{ orderInvalid.total}}
                  </span>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel *ngFor="let orderToVerify of ordersFiltered.toVerify"
              class="mt-2 flex flex-col rounded-md bg-orange-300" hideToggle [expanded]="!orderToVerify.collapsed">
              <mat-expansion-panel-header class="hover:bg-orange-400">
                <mat-panel-title>
                  <span class="flex flex-row content-center">
                    Necesita Validación
                    <mat-icon class="ml-2 text-orange-600" svgIcon="heroicons_outline:hand-raised"></mat-icon>
                  </span>
                </mat-panel-title>
                <mat-panel-description> #{{ orderToVerify.code }} </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="flex flex-row justify-between text-black mb-2">
                <div class="flex flex-col">
                  <span>
                    Orden Para:
                  </span>
                  <span>
                    {{ orderToVerify.soldTo.name }}
                  </span>
                </div>
                <div class="flex flex-col">
                  <span>
                    Se entrega en:
                  </span>
                  <span>
                    {{ orderToVerify.shipTo.address.address }}
                  </span>
                </div>
                <div class="flex flex-col">
                  <span>
                    Se entrega a:
                  </span>
                  <span>
                    {{ orderToVerify.shipTo.name }}
                  </span>
                </div>
                <div class="flex flex-col custom-max-w-12">
                  <span class="flex items-center">
                    Fecha de entrega:
                    <mat-icon matTooltip="Fecha con posible conflicto, por favor verificar"
                      class="h-4 w-4 min-h-0 min-w-0 text-orange-700 ml-2"
                      svgIcon="heroicons_outline:question-mark-circle">
                    </mat-icon>
                  </span>
                  <mat-form-field>
                    <input matInput [matDatepicker]="picker" [value]="orderToVerify.deliveryDateTimeSuggested">
                    <mat-hint class="text-center">MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
              <div>
                <div class="border-b w-full text-start mb-2">
                  <span class="text-xl text-orange-600 font-semibold">
                    Materiales
                  </span>
                </div>
                <div *ngFor="let material of orderToVerify.detail; let i = index"
                  class="flex justify-between text-neutral-800"
                  [ngClass]="(i + 1) === orderToVerify.detail.length ? 'border-b' : '' ">
                  <span>
                    {{ material.name }}
                  </span>
                  <span>
                    {{ material.price}}
                  </span>
                </div>
                <div class="flex justify-between text-neutral-800 mt-2">
                  <span>
                    Total de la orden
                  </span>
                  <span>
                    {{ orderToVerify.total}}
                  </span>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel *ngFor="let orderValid of ordersFiltered.valid"
              class="mt-2 flex flex-col border-teal-700 rounded-md border-solid bg-teal-400" hideToggle
              [expanded]="!orderValid.collapsed">
              <mat-expansion-panel-header class="hover:bg-teal-600">
                <mat-panel-title> Orden Válida </mat-panel-title>
                <mat-panel-description> #{{ orderValid.code }} </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="flex flex-row justify-between text-black mb-2">
                <div class="flex flex-col">
                  <span>
                    Orden Para:
                  </span>
                  <span>
                    {{ orderValid.soldTo.name }}
                  </span>
                </div>
                <div class="flex flex-col">
                  <span>
                    Se entrega en:
                  </span>
                  <span>
                    {{ orderValid.shipTo.address.address }}
                  </span>
                </div>
                <div class="flex flex-col">
                  <span>
                    Se entrega a:
                  </span>
                  <span>
                    {{ orderValid.shipTo.name }}
                  </span>
                </div>
                <div class="flex flex-col custom-max-w-12">
                  <span>
                    Fecha de entrega:
                  </span>
                  <mat-form-field>
                    <input matInput [matDatepicker]="picker" [value]="orderValid.deliveryDateTime">
                    <mat-hint>MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
              <div>
                <div class="border-b w-full text-start mb-2">
                  <span class="text-xl text-teal-700 font-semibold">
                    Materiales
                  </span>
                </div>
                <div *ngFor="let material of orderValid.detail; let i = index"
                  class="flex justify-between text-neutral-800"
                  [ngClass]="(i + 1) === orderValid.detail.length ? 'border-b' : '' ">
                  <span>
                    {{ material.name }}
                  </span>
                  <span>
                    {{ material.price}}
                  </span>
                </div>
                <div class="flex justify-between text-neutral-800 mt-2">
                  <span>
                    Total de la orden
                  </span>
                  <span>
                    {{ orderValid.total}}
                  </span>
                </div>
              </div>
            </mat-expansion-panel>
          </div>
        </mat-accordion>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button mat-raised-button color="primary" mat-dialog-close>Confirmar Órdenes</button>
      </mat-dialog-actions>
    </ng-template>

  </div>

  <!-- NG-TEMPLATES -->
  <ng-template #selectionPending>
    <span>
      Pendiente a seleccionar
    </span>
  </ng-template>
</mat-sidenav-container>